import React, { Component } from "react";

import colors from "../../colors";
// import menu from "../data/data";//menu
import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
const home =
  "<ul> <li>To develop a short-term snowmelt runoff forecasting model using satellite derived products and field data&nbsp;</li> </ul> <ul> <li>To generate a spatial daily gridded snowmelt product&nbsp;</li> </ul> <ul> <li>To generate a spatial 3-day snowmelt forecast gridded product&nbsp;</li> </ul> <ul> <li>To provide short term snowmelt runoff forecast at selected basin outlets during snow melt season&nbsp;</li> </ul> <ul> <li>To provide seasonal forecast at selected basin outlets during snow melt season</li> </ul> <p>&nbsp;</p>";

export default class SProjObjective extends Component {
  render() {
    return (
      <div
      className="cardeck_full"
     
    >
      <div className="carddeck_inner"
        style={{
        
          backgroundColor: colors.background,
        }}
      >
          <Slider />

          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div
              className="card"
              style={{ padding: "15px", width: "100%", height: "100%" }}
            >
              {/* <main style={{flexGrow: "1", width:"100%", height:"100%", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
      <div className="card"> */}
              <div className="card-body">
                <h3 className="card-title" style={{ color: "#002171" }}>
                  Development of Spatial Snowmelt Runoff product in the Indian
                  Himalayas
                </h3>
                <hr />
                {ReactHtmlParser(home)}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
